<script setup lang="ts">
defineProps({
  modelValue: {},
})

const emit = defineEmits(['update:modelValue'])

const changeHandler = (e: any) => {
  emit('update:modelValue', !!e.target.checked)
}

const id = useId()
</script>

<template>
  <div class="switch">
    <input :id class="switch__input" type="checkbox" @input="changeHandler" :checked="modelValue" />
    <label :for="id" class="switch__slider"></label>
  </div>
</template>

<style lang="scss">
@use '/assets/scss/components/switch' as *;
</style>
